import rgb2hsl from './rgb-to-hsl';
import hex2rgb from './hex-to-rgb';

const hex2hsl = (hexColor) => rgb2hsl(hex2rgb(hexColor));

export default hex2hsl;
